// extracted by extract-css-chunks-webpack-plugin
module.exports = {"select_share":"select_share-2dBhRHzU","header":"header-1-LFp2BE"};